/**
 * Fires the Utmify "AddToCart" pixel event.
 * Call this on every "add to cart" button click.
 */
export function trackAddToCart() {
  try {
    // @ts-ignore — utmify attaches to window after pixel.js loads
    if (typeof window !== 'undefined' && window.utmify) {
      // @ts-ignore
      window.utmify('track', 'AddToCart')
    }
  } catch (e) {
    // Silently fail if pixel hasn't loaded yet
  }
}
